import { ReportGeneratorTemplate } from './report-generator-template';

export class ReportGeneratorTemplatesResponse {
  templates: ReportGeneratorTemplate[];
}
